import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import IconSvg from "../../../SharedComponents/IconSvg";

const MobileWarningModal = ({ show, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title className="fw-semibold">{t("mobileWarning.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="mx-0">
          <Col xs={12} className="text-center mb-4">
            <IconSvg icon="warning-black-outline" width={64} height={64} />
          </Col>
          <Col xs={12}>
            <p className="text-16 text-center mb-3">{t("mobileWarning.message")}</p>
            <p className="text-14 text-color-gray-dark text-center">{t("mobileWarning.recommendation")}</p>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button className="button primary" onClick={onClose}>
          {t("mobileWarning.understood")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MobileWarningModal;
